import React, { useState, FC, PropsWithChildren, useEffect } from "react"

import {
    collectionGroup,
    FirestoreError,
    limit,
    onSnapshot,
    orderBy,
    query,
    Timestamp,
    where,
} from "firebase/firestore"

import { AggregatedObservationsDocuments, INIT_AGGREGATED_OBSERVATIONS, StatisticsContext } from "."
import { firebase } from "../../services/firebase/firebase"
import observationConverter from "../observations-context/utils/observationConverter"
import dayjs from "dayjs"
import { Outlet } from "react-router-dom"
import aggregateObservations from "./utils/aggregateObservations"

type StatisticsProviderProps = {
    route?: boolean
}

export const StatisticsProvider: FC<PropsWithChildren<StatisticsProviderProps>> = ({ children, route = false }) => {
    const [dataNow, setDataNow] = useState<AggregatedObservationsDocuments>(INIT_AGGREGATED_OBSERVATIONS)
    const [dataPrior, setDataPrior] = useState<AggregatedObservationsDocuments>(INIT_AGGREGATED_OBSERVATIONS)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState<FirestoreError>()

    useEffect(
        () =>
            onSnapshot(
                query(
                    collectionGroup(firebase.firestore, `observations`),
                    where("type", "==", "feeding"),
                    where("timestamp", "<=", Timestamp.fromDate(dayjs().toDate())),
                    where("timestamp", ">", Timestamp.fromDate(dayjs().subtract(24, "hours").toDate())),
                    orderBy("timestamp", "desc"),
                    limit(1000),
                ).withConverter(observationConverter),
                snapshot => {
                    const docs = snapshot.docs.map(doc => doc.data())
                    setDataNow(aggregateObservations(docs))
                    setLoading(false)
                },
                setError,
            ),
        [],
    )

    useEffect(
        () =>
            onSnapshot(
                query(
                    collectionGroup(firebase.firestore, `observations`),
                    where("type", "==", "feeding"),
                    where("timestamp", "<=", Timestamp.fromDate(dayjs().subtract(24, "hours").toDate())),
                    where("timestamp", ">", Timestamp.fromDate(dayjs().subtract(48, "hours").toDate())),
                    orderBy("timestamp", "desc"),
                    limit(1000),
                ).withConverter(observationConverter),
                snapshot => {
                    const docs = snapshot.docs.map(doc => doc.data())
                    setDataPrior(aggregateObservations(docs))
                    setLoading(false)
                },
                setError,
            ),
        [],
    )

    useEffect(() => {
        if (error) console.error(error)
    }, [error])

    return (
        <StatisticsContext.Provider value={{ dataNow, dataPrior, loading, error }}>
            {route ? <Outlet /> : children}
        </StatisticsContext.Provider>
    )
}
